<div class="accordion" id="sessionTypeAccordion" (click)="$event.stopPropagation()">
  @for ( session of sessions; track session.id) {
  <div class="accordion-item" [class.accordion-item--active]="selectedSessionType() === session.id" [class.collapsed]="!isExpanded(session.id)">
    <button (click)="onSessionTypeClick(session.id)" class="accordion-toggle accordion-header" [attr.aria-controls]="session.id" data-bs-toggle="collapse"
      type="button" [attr.data-bs-target]="'#' + session.id">
      <i class="icon-anchor"></i> {{ session.title }}

      @if (session.recommended) {
      <span class="recommended-badge">recommended</span>
      }
    </button>

    <p class="preview-text">
      {{ session.previewText
            }}<span [hidden]="isExpanded(session.id)" *ngIf="!session.previewText.endsWith('.')">...</span>
    </p>

    <div [id]="session.id" class="accordion-collapse collapse" data-bs-parent="#sessionTypeAccordion" [class.show]="isExpanded(session.id)">
      <div class="accordion-body">
        <div class="text-wrapper">
          <p class="mt-0">
            {{ session.content.description }}
          </p>

          @if (session.content.whyChoose) {
          <p>Why choose this: {{ session.content.whyChoose }}</p>
          }

          <p>Choose this if:</p>
          <ul class="conditions-list">
            <li *ngFor="let condition of session.content.conditions">
              {{ condition }}
            </li>
          </ul>

          <p>
            How it works at a glance: <br />
            {{ session.content.howItWorks }}
          </p>
        </div>

        <img [src]="session.content.imageSrc" [alt]="session.content.imageAlt" class="w-100" />
      </div>
    </div>
  </div>
  }
</div>
